// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__GJbtN","success":"styles_success__T35vk"};